import { css } from 'twin.macro';
import React, { useState, useEffect, Fragment } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Modal, Form } from 'react-bootstrap';
import { fetchWrapper, formatAMPM, formatDate } from '../../../_helpers';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import {
    editTheTask,
    editMyTask,
    editTaskStatus,
    editMyTaskAttendance,
    fetchUpcomingTasks,
} from '../../../_redux/actions/ActionTasks';
import { getRecurrenceData, nthDay, days } from '../../Features/Events/CustomRecurrence';
import { CustFormLabel } from '../../../_elements/formLabel';
import { customCheckbox } from '../../../_elements/CustomCheckbox';
import { useMemo } from 'react';
import { MdCall } from 'react-icons/md';
import dayjs from 'dayjs';
import { createEvent } from 'ics';
import { saveAs } from 'file-saver';
import { BsChatDots, BsClock, BsGeoAlt, BsPeople, BsLink45Deg, BsDownload, BsCheckCircle } from 'react-icons/bs';
import { BootstrapToolTip } from '../../../_elements/ToolTip';
import { startConference, setConferenceData } from '../../../_redux/actions/ActionConference';

import FormViewAccordion from './FormViewAccordion';
import { CiBellOff, CiBellOn } from 'react-icons/ci';

import { HiOutlineExclamationCircle } from 'react-icons/hi';
import { toast } from 'react-toastify';
import { GoToChannel } from '@/_elements/Links';
import {
    EventLocationComponent,
    DescriptionComponent,
    ToggleContentContainer,
    EventParticipantStatusComponent,
    EventAttendanceComponent,
    EventRecurringComponent,
} from './EventComponents/EventPreviewShowHideComponents';
import { GiAlarmClock } from 'react-icons/gi';
import ExternalCalendarEventViewControl from '@/components/Features/CalendarIntegration/components/ExternalCalendarEventControl';
import { REMINDER_SET } from '@/contants';
import { buildEventUrl, checkEventConflicts, getNameInitials } from './EventComponents/utils';
import EventTypePreview from '@/components/Features/Events/EventTypePreview';
import EventPlanProgress from './EventComponents/EventPlanProgress';
import EventTrainingCourses from './EventComponents/EventTrainingCourses';

const PreviewEventModalForm = React.memo(
    ({
        data: initialData,
        handleClose,
        editTheTask,
        editMyTask,
        editTaskStatus,
        startConference,
        setConferenceData,
        editMyTaskAttendance,
        currUser,
        handleUpdateTask = () => {},
        fetchUpcomingTasks,
    }) => {
        const [data, setData] = useState(initialData);
        const [plan, setPlan] = useState(null);
        useEffect(() => {
            setData(initialData);
        }, [initialData]);
        const [isLoadingPlan, setIsLoadingPlan] = useState(false);

        useEffect(() => {
            const fetchPackageEvents = async () => {
                try {
                    const packageId = data?.eventPackage?._id || data?.eventPackage;
                    if (!packageId) return;
                    setIsLoadingPlan(true);
                    const response = await fetchWrapper.get(`activityPackages/${packageId}`);
                    const eventPackage = Array.isArray(response) && response.length ? response[0] : response;
                    setPlan(eventPackage);
                } catch (err) {
                    console.error('Failed to fetch package events', err);
                } finally {
                    setIsLoadingPlan(false);
                }
            };
            fetchPackageEvents();
        }, [data?.eventPackage]);

        const { assignedChannel, recurringUntil } = data;
        const id = data._id || data.id;
        const teams = useSelector((state) => state.teams?.teams);
        const userId = useSelector((state) => state.user?.user?.id);
        const position = useSelector((state) => state.user.position);
        const assignedChannelInfo = Array.isArray(data?.assignedChannelInfo)
            ? data.assignedChannelInfo[0]
            : data?.assignedChannelInfo;
        const [selectedRoomOption, setSelectedRoomOption] = useState(
            assignedChannelInfo && {
                label: assignedChannelInfo?.title,
                value: assignedChannelInfo?._id,
            }
        );
        const [loadingUsersData, setLoadingUsersData] = useState(true);
        const [currRoom, setCurrRoom] = useState({});
        const [team, setTeam] = useState({});
        const forms = data?.formsData || [];
        const [showRecurring, setShowRecurring] = useState(Boolean(data?.recurring) || false);
        const selectedUsers = data?.assignedUserData || [];
        const [isShowing, setIsShowing] = useState(false);
        const [taskStatus, setTaskStatus] = useState(data?.status);
        const [userStartReminder, setUserStartReminder] = useState(data?.userStartReminders || []);
        const initialStartReminder = data?.userStartReminders || [];
        const [userEndReminder, setUserEndReminder] = useState(data?.userEndReminders || []);
        const initialEndReminder = data?.userEndReminders || [];
        const [selectedCourses, setSelectedCourses] = useState(
            data?.trainings?.map((course) => {
                return {
                    label: course.title,
                    value: course._id,
                    index: course.index,
                };
            }) || []
        );
        const { register } = useForm({
            mode: 'onBlur',
        });
        const isExternalEvent = useMemo(() => {
            return data?.externalEvent || data?.calendarProvider;
        }, [data]);
        const [eventResponse, setEventResponse] = useState({});
        const [newEventResponse, setNewEventResponse] = useState();
        const [isBusy, setIsBusy] = useState(false);
        const [isNotificationDisabled, setIsNotificationDisabled] = useState(
            (data?.notificationDisabledFor || []).includes(currUser?._id)
        );
        const [conflictEndTime, setConflictEndTime] = useState(null);
        const [conflictEventTitle, setConflictEventTitle] = useState(null);
        const [loadingConflict, setLoadingConflict] = useState(false);

        useEffect(() => {
            const fetchUsersData = async () => {
                try {
                    let chatroomId;
                    if (selectedRoomOption && selectedRoomOption.value) {
                        chatroomId = selectedRoomOption.value;
                    } else if (data) {
                        chatroomId = Array.isArray(data.assignedChannel)
                            ? data.assignedChannel[0]
                            : data.assignedChannel?.value || data.assignedChannel;
                    }
                    if (chatroomId) {
                        const chatroomData = await fetchWrapper.get(`/chatrooms/${chatroomId}`);
                        setCurrRoom(chatroomData);
                        const teamId = chatroomData.team;
                        const teamData = teams.find((team) => (team.id || team._id) === teamId);
                        setTeam(teamData);
                    }
                } catch (err) {
                    console.log(err);
                } finally {
                    setLoadingUsersData(false);
                }
            };
            fetchUsersData();
        }, [data?._id, selectedRoomOption?.value]);

        const handleSave = () => {
            createEvent(newEventResponse, (error, value) => {
                const blob = new Blob([value], { type: 'text/plain;charset=utf-8' });
                saveAs(blob, 'event-schedule.ics');
            });
        };
        const fetchRes = async () => {
            try {
                const res = await fetchWrapper.get(`task/${id}`);
                setEventResponse(res);
            } catch (err) {
                console.log(err);
            }
        };

        const handleUserStartReminderChange = (event) => {
            let reminder = event.target.value;
            let newUserStartReminder = [...userStartReminder];
            let reminderIndex = newUserStartReminder.indexOf(reminder);
            let permissionGiven = Boolean(reminderIndex >= 0);
            if (permissionGiven) {
                newUserStartReminder.splice(reminderIndex, 1);
            } else {
                newUserStartReminder.push(reminder);
            }
            setUserStartReminder(newUserStartReminder);
        };

        const handleUserEndReminderChange = (event) => {
            let reminder = event.target.value;
            let newUserEndReminder = [...userEndReminder];
            let reminderIndex = newUserEndReminder.indexOf(reminder);
            let permissionGiven = Boolean(reminderIndex >= 0);
            if (permissionGiven) {
                newUserEndReminder.splice(reminderIndex, 1);
            } else {
                newUserEndReminder.push(reminder);
            }
            setUserEndReminder(newUserEndReminder);
        };
        const checkIsShowing = (show) => {
            setIsShowing(show);
        };

        const isAssigned = useMemo(() => {
            return Boolean(selectedUsers?.find((selectedUser) => selectedUser._id === userId));
        }, [selectedUsers, userId]);

        const isMeetingTime = useMemo(() => {
            const startTime = dayjs(data.date).format('HH:mm');
            const endTime = dayjs(data.dueDate).format('HH:mm');
            const currentTime = dayjs().format('HH:mm');
            const startNumber = Number(startTime.split(':').join(''));
            const endNumber = Number(endTime.split(':').join(''));
            const currenttNumber = Number(currentTime.split(':').join(''));
            if (currenttNumber >= startNumber && currenttNumber <= endNumber) {
                return true;
            } else {
                return false;
            }
        }, [data.date, data.dueDate]);

        // Compact header meta
        const startAt = useMemo(
            () => dayjs(data?.latestDatePointer || data?.date),
            [data?.latestDatePointer, data?.date]
        );
        const endAt = useMemo(
            () => dayjs(data?.latestDueDatePointer || data?.dueDate),
            [data?.latestDueDatePointer, data?.dueDate]
        );
        const hasEnd = Boolean(data?.latestDueDatePointer || data?.dueDate);
        const durationLabel = useMemo(() => {
            if (!hasEnd) return null;
            const mins = endAt.diff(startAt, 'minute');
            const h = Math.floor(mins / 60);
            const m = mins % 60;
            return `${h ? `${h}h ` : ''}${m}m`;
        }, [startAt, endAt, hasEnd]);
        const dateLabel = useMemo(() => startAt.format('ddd, MMM D, YYYY'), [startAt]);
        const timeLabel = useMemo(
            () => `${startAt.format('h:mm A')}${hasEnd ? ` – ${endAt.format('h:mm A')}` : ''}`,
            [startAt, endAt, hasEnd]
        );

        const onCopyLink = async () => {
            try {
                if (data && data?.htmlLink) {
                    await navigator.clipboard.writeText(data?.htmlLink);
                    return toast.info('Event Link copied');
                }
                await navigator.clipboard.writeText(buildEventUrl(data));
                toast.info('Event Link copied');
            } catch (e) {
                toast.error('Copy failed');
            }
        };

        const participantsInitials = (selectedUsers || []).map((u) => getNameInitials(u?.name || ''));
        const isSelfDone = useMemo(() => (taskStatus || []).includes(currUser?._id), [taskStatus, currUser?._id]);
        const toggleSelfComplete = () => handleStatusChange(currUser?._id, isSelfDone ? 'incomplete' : 'done');
        const [recurringMessage, setRecurringMessage] = useState('');

        const handleCall = async () => {
            try {
                let room;
                if (data?.assignedChannel?.length) {
                    room = data?.assignedChannel[0];
                    const response = await fetchWrapper.post('/conference/token', { room: room });
                    setConferenceData(room, response.id, team?.id || team?._id);
                    startConference();
                }
            } catch (e) {}
        };

        const handleStatusChange = async (targetUserId, status) => {
            try {
                setIsBusy(true);
                const updatedTaskStatus =
                    status === 'done'
                        ? [...taskStatus, targetUserId]
                        : taskStatus.filter((value) => value !== targetUserId);
                const isEdited = await editTaskStatus(data._id, { status: updatedTaskStatus }, status);
                if (isEdited) {
                    setTaskStatus(updatedTaskStatus);
                    if (plan && plan?.taskData) {
                        setPlan((prev) => ({
                            ...prev,
                            taskData: prev.taskData.map((_task) => {
                                if ((_task._id || _task.id) === (data._id || data.id)) {
                                    return {
                                        ..._task,
                                        status: updatedTaskStatus,
                                    };
                                }
                                return _task;
                            }),
                        }));
                    }
                }
            } catch (error) {
                toast.error(error.message || 'Failed to update status');
            } finally {
                setIsBusy(false);
            }
        };

        const handleEditClick = async (id) => {
            try {
                setIsBusy(true);

                const newTasks = {
                    title: data?.title,
                    date: data?.date,
                    dueDate: data?.dueDate,
                    status: data?.status,
                    eventType: data?.eventType?._id || data?.eventType.id || data?.eventType,
                    assignedChannel: [
                        Array.isArray(assignedChannel)
                            ? assignedChannel[0]
                            : assignedChannel?._id || assignedChannel?.id,
                    ],
                    assignedUser: data?.assignedUser,
                    userStartReminders: userStartReminder,
                    userEndReminders: userEndReminder,
                    recurring: data?.recurring,
                };
                const success = await editTheTask(id, newTasks);
                return success;
            } catch (error) {
            } finally {
                setIsBusy(false);
            }
        };

        const handleEventChannelClick = (userId) => {
            const userSubChannel = userId && data.subChannel?.find(({ owner }) => owner === userId);
            if (userSubChannel) {
                const url = `/event-channel/${userSubChannel._id || userSubChannel.id}`;
                window.open(url, '_blank');
            }
        };

        useEffect(() => {
            const startDate = new Date(data?.latestDatePointer || data?.date);
            const recurrenceData = data?.recurring ? getRecurrenceData(data.recurring, startDate) : {};

            if (recurrenceData?.num && recurrenceData?.unit) {
                const eventStartDateTime = startDate ? new Date(startDate) : new Date();
                const unitString =
                    recurrenceData.num > 1
                        ? recurrenceData.num + ' ' + recurrenceData.unit
                        : recurrenceData.unit?.replace('s', '');
                let message = `The event will reoccur every ${unitString}`;
                if (recurrenceData.unit === 'weeks' || (recurrenceData.unit === 'months' && recurrenceData.week)) {
                    message += ` on ${recurrenceData.unit === 'months' ? nthDay[recurrenceData.week] + ' ' : ''}${recurrenceData.days.map((x) => days[x]).join(', ')} at ${formatAMPM(eventStartDateTime)}`;
                } else {
                    message += ` at ${recurrenceData.unit === 'days' ? formatAMPM(eventStartDateTime) : formatDate(eventStartDateTime, recurrenceData.unit !== 'months')}`;
                }
                setRecurringMessage(
                    `${message}${recurringUntil ? ` until ${formatDate(new Date(recurringUntil))}` : ' forever'}`
                );
            }
        }, [data?.recurring, data?.recurringUntil]);

        const canSeeAllStatus =
            currUser.role === 'admin' ||
            currUser._id === (data.assignedBy?.id || data.assignedBy) ||
            currUser.teamList.some(
                (data) =>
                    data.team?._id?.toString() === team?._id?.toString() && ['owner', 'teamManager'].includes(data.role)
            ) ||
            currUser.roomList.some(
                ({ room, role }) => room?._id?.toString() === currRoom?._id?.toString() && role === 'supervisor'
            );

        const checkConflicts = async () => {
            await checkEventConflicts(data, currUser, {
                setLoadingConflict,
                setConflictEndTime,
                setConflictEventTitle,
            });
        };
        const updateAttendance = async (id, updateData = {}) => {
            try {
                setIsBusy(true);
                const response = await editMyTaskAttendance(data._id, { ...updateData });
                if (updateData.status === 'accepted') await checkConflicts();
                handleUpdateTask(data?._id || data?.id, {
                    attendance: response,
                });
                fetchUpcomingTasks();
                if (response) {
                    return response?.status;
                }
            } catch (e) {
                console.error(e);
            } finally {
                setIsBusy(false);
            }
        };

        const handleUpdateNotification = async () => {
            try {
                setIsBusy(true);
                const success = await editMyTask(data?._id || data?.id, {
                    disableNotification: !isNotificationDisabled,
                });
                handleUpdateTask(data?._id || data?.id, {
                    notificationDisabledFor: success?.notificationDisabledFor,
                });
                if (success) {
                    if ((success?.notificationDisabledFor || []).includes(currUser?._id)) {
                        return toast.success('Notifications are disabled for this event');
                    }
                    return toast.success('Notifications are enabled for this event');
                }
            } catch (error) {
            } finally {
                setIsBusy(false);
            }
        };
        useEffect(() => {
            if (Boolean(data?.recurring)) {
                setShowRecurring(true);
            } else {
                setShowRecurring(false);
            }
        }, [data?.recurring]);
        useEffect(() => {
            if (data?.title) {
                setEventResponse(data);
                setUserStartReminder((prev) => data?.userStartReminders || [...prev]);
                setUserEndReminder((prev) => data?.userEndReminders || [...prev]);
                setTaskStatus(data?.status || []);
                const assignedChannelInfo = Array.isArray(data?.assignedChannelInfo)
                    ? data.assignedChannelInfo[0]
                    : data?.assignedChannelInfo;
                if (assignedChannelInfo) {
                    setSelectedRoomOption({
                        label: assignedChannelInfo?.title,
                        value: assignedChannelInfo?._id,
                    });
                }
                setSelectedCourses(
                    data?.trainings?.map((course) => {
                        return {
                            label: course.title,
                            value: course._id,
                            index: course.index,
                        };
                    }) || []
                );
            } else if (id) {
                fetchRes();
            }
        }, [id, data]);

        useEffect(() => {
            if (eventResponse) {
                const isoDate = eventResponse?.latestDatePointer;
                const date = new Date(isoDate);
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const hour = date.getHours();
                const minute = date.getMinutes();
                const formattedDate = [year, month, day, hour, minute];
                const startDateString = eventResponse?.date;
                const endDateString = eventResponse?.dueDate;
                const startDate = new Date(startDateString);
                const endDate = new Date(endDateString);
                const durationInMs = endDate - startDate;
                const durationInMinutes = Math.floor(durationInMs / (1000 * 60));
                const hours = Math.floor(durationInMinutes / 60);
                const minutes = durationInMinutes % 60;
                const duration = { hours: hours, minutes: minutes };

                const newEventResponse = {
                    start: formattedDate,
                    duration: duration,
                    title: eventResponse?.title,
                    description: eventResponse?.description,
                };
                setNewEventResponse(newEventResponse);
                setIsNotificationDisabled((eventResponse?.notificationDisabledFor || []).includes(currUser?._id));
            }
        }, [eventResponse]);
        return (
            <div
                css={css`
                    ${isShowing ? 'opacity: 0.3' : ''}
                `}
            >
                <Modal.Header className="d-flex align-items-center justify-content-end">
                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                        <BootstrapToolTip text="Open chat">
                            <Button
                                variant="light"
                                onClick={() => handleEventChannelClick(currUser?._id)}
                                disabled={data?.externalEvent}
                            >
                                <BsChatDots size={20} />
                            </Button>
                        </BootstrapToolTip>
                        <BootstrapToolTip text="Copy link">
                            <Button variant="light" onClick={onCopyLink}>
                                <BsLink45Deg size={20} />
                            </Button>
                        </BootstrapToolTip>
                        <BootstrapToolTip text="Download .ics">
                            <Button variant="light" onClick={handleSave}>
                                <BsDownload size={20} />
                            </Button>
                        </BootstrapToolTip>
                        <BootstrapToolTip
                            text={`${isNotificationDisabled ? 'Turn on Notifications' : 'Turn off Notifications'} for this event`}
                        >
                            <Button
                                variant="light"
                                onClick={handleUpdateNotification}
                                disabled={isBusy || data?.externalEvent}
                            >
                                {isNotificationDisabled ? <CiBellOff size={20} /> : <CiBellOn size={20} />}
                            </Button>
                        </BootstrapToolTip>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ height: '75vh', overflowY: 'scroll', overflowX: 'clip' }} className="px-5">
                    <EventPlanProgress plan={plan} data={data} setData={setData} isLoading={isLoadingPlan} />
                    <div className="  d-flex align-items-center justify-content-between">
                        <div className=" ">
                            <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                                {[
                                    data?.eventType?.name || data?.eventType?.title,
                                    startAt.isAfter(dayjs()) ? 'Scheduled' : null,
                                    data?.eventMode === 'live' ? 'Live' : null,
                                    data?.eventPackage ? 'Licensing' : null,
                                ]
                                    .filter(Boolean)
                                    .map((label = '') => (
                                        <span
                                            key={label}
                                            style={{
                                                backgroundColor:
                                                    label?.toLowerCase() === 'live' ? '#c93535' : '#ebebeb',
                                            }}
                                            className={`badge ${label?.toLowerCase() === 'live' ? 'badge-danger' : ''}`}
                                        >
                                            {label}
                                        </span>
                                    ))}
                            </div>
                            <div
                                className="mt-2"
                                css={css`
                                    font-size: 20px;
                                    font-weight: 600;
                                `}
                            >
                                {data?.title || 'New Task'}
                            </div>
                        </div>
                        <EventTypePreview task={data} imageOnly={true} />
                    </div>

                    <div className=" mt-2 d-flex align-items-center justify-content-between">
                        <div
                            className="d-flex align-items-center text-muted"
                            css={css`
                                font-size: 1.6rem;
                            `}
                        >
                            <BsClock className="mr-2" /> {dateLabel}, {timeLabel}
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                            {durationLabel ? <span className="badge badge-light">{durationLabel}</span> : null}
                            <div
                                className="text-muted d-flex align-items-center"
                                css={css`
                                    font-size: 14px;
                                `}
                            >
                                <GoToChannel
                                    channel={selectedRoomOption}
                                    iconComponent={BsGeoAlt}
                                    iconPosition="left"
                                    size={14}
                                />
                            </div>
                        </div>
                    </div>

                    <div className=" mt-2 d-flex align-items-center justify-content-between">
                        <div
                            className="d-flex align-items-center text-muted"
                            css={css`
                                font-size: 1.6rem;
                            `}
                        >
                            <BsPeople className="mr-2" /> Participants
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: 8 }}>
                            {participantsInitials.slice(0, 4).map((ini, idx) => (
                                <span
                                    key={idx}
                                    css={css`
                                        font-weight: 600;
                                    `}
                                >
                                    {ini}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="mt-2">
                        <DescriptionComponent data={data} />
                    </div>

                    {isExternalEvent && (
                        <ExternalCalendarEventViewControl event={data} showCalendarIcon={false} textMode={true} />
                    )}

                    <div className="mt-4">
                        <FormViewAccordion
                            selectedForm={forms}
                            selectedUsers={selectedUsers}
                            subTasks={data.subTasks}
                            canSubmitForm={true}
                            userId={userId}
                            currUser={currUser}
                            currRoom={currRoom}
                            team={team}
                            position={position}
                            checkIsShowing={checkIsShowing}
                            data={data}
                            canSeeAllStatus={canSeeAllStatus}
                        />
                    </div>

                    <div className="mt-4">
                        <EventLocationComponent data={data} />
                    </div>
                    <div className="mt-4">
                        <EventParticipantStatusComponent
                            data={data}
                            isExternalEvent={isExternalEvent}
                            loadingUsersData={loadingUsersData}
                            selectedUsers={selectedUsers}
                            currUser={currUser}
                            canSeeAllStatus={canSeeAllStatus}
                            handleStatusChange={handleStatusChange}
                            register={register}
                            handleEventChannelClick={handleEventChannelClick}
                            taskStatus={taskStatus}
                        />
                    </div>
                    {isExternalEvent ? null : (
                        <div className="mt-4">
                            <ToggleContentContainer show={false} toggleText="Reminders" IconComponent={GiAlarmClock}>
                                <>
                                    <div className="">
                                        <CustFormLabel>User Start Reminder</CustFormLabel>
                                        <div className="my-2 d-flex flex-wrap">
                                            {REMINDER_SET['All'].map((rem) => (
                                                <div key={rem.value} className="d-flex align-items-center mr-3 mb-1">
                                                    <input
                                                        id={`userstart-${rem.value}`}
                                                        type="checkbox"
                                                        css={customCheckbox}
                                                        onChange={handleUserStartReminderChange}
                                                        value={rem.value}
                                                        checked={userStartReminder.includes(rem.value)}
                                                    />
                                                    <label htmlFor={`userstart-${rem.value}`} className="ml-1 mb-0">
                                                        {rem.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        {userStartReminder?.length > 0 ? (
                                            <Form.Text className="small font-italic text-muted">
                                                We will remind you{' '}
                                                {userStartReminder.map((reminder, idx) =>
                                                    idx === 0 ? reminder : `, ${reminder}`
                                                )}{' '}
                                                before the event starts.
                                            </Form.Text>
                                        ) : null}
                                    </div>
                                    <div className=" mt-3">
                                        <CustFormLabel>User End Reminder</CustFormLabel>
                                        <div className="my-2 d-flex flex-wrap">
                                            {REMINDER_SET['All'].map((rem) => (
                                                <div key={rem.value} className="d-flex align-items-center mr-3 mb-1">
                                                    <input
                                                        id={`userend-${rem.value}`}
                                                        type="checkbox"
                                                        css={customCheckbox}
                                                        onChange={handleUserEndReminderChange}
                                                        value={rem.value}
                                                        checked={userEndReminder.includes(rem.value)}
                                                    />
                                                    <label htmlFor={`userend-${rem.value}`} className="ml-1 mb-0">
                                                        {rem.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        {userEndReminder?.length > 0 ? (
                                            <Form.Text className="small font-italic text-muted">
                                                We will remind you{' '}
                                                {userEndReminder.map((reminder, idx) =>
                                                    idx === 0 ? reminder : `, ${reminder}`
                                                )}{' '}
                                                before the event ends.
                                            </Form.Text>
                                        ) : null}

                                        {(userStartReminder.length !== initialStartReminder.length ||
                                            userEndReminder.length !== initialEndReminder.length ||
                                            userStartReminder.some((item) => !initialStartReminder.includes(item)) ||
                                            userEndReminder.length !== initialEndReminder.length ||
                                            userEndReminder.some((item) => !initialEndReminder.includes(item))) && (
                                            <div className="d-flex w-100 justify-content-end mt-2">
                                                <Button
                                                    onClick={async () => await handleEditClick(data?._id)}
                                                    disabled={isBusy}
                                                >
                                                    Edit Reminder{' '}
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </>
                            </ToggleContentContainer>
                        </div>
                    )}

                    {showRecurring && data?.eventMode === 'live' ? (
                        <div className="mt-4">
                            <EventRecurringComponent
                                data={data}
                                recurringMessage={recurringMessage}
                                getRecurrenceData={getRecurrenceData}
                                recurringUntil={recurringUntil}
                            />
                        </div>
                    ) : null}

                    {isAssigned && (
                        <div className="mt-4">
                            <EventAttendanceComponent
                                key={data}
                                data={data}
                                isBusy={isBusy}
                                conflictEndTime={conflictEndTime}
                                conflictEventTitle={conflictEventTitle}
                                updateAttendance={updateAttendance}
                                userId={currUser?._id}
                                disabled={isBusy || loadingConflict}
                                loadingConflict={loadingConflict}
                                checkConflicts={checkConflicts}
                            />
                        </div>
                    )}

                    {/* Conference */}
                    {data?.hasConference && (
                        <div className=" mt-4">
                            {isAssigned && (
                                <Fragment>
                                    <CustFormLabel>Conference</CustFormLabel>
                                    {isMeetingTime ? (
                                        <Button className="d-flex align-items-center" onClick={handleCall}>
                                            <MdCall className="mr-2" /> Join Conference
                                        </Button>
                                    ) : (
                                        <div className="alert alert-info d-flex align-items-center">
                                            <MdCall className="mr-2" /> Conference will begin at
                                            <b className="ml-2">{dayjs(data.date).format('hh:mm A')}</b>
                                        </div>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    )}

                    {/* Courses */}
                    <EventTrainingCourses data={data} selectedCourses={selectedCourses} />
                </Modal.Body>
                <Modal.Footer className="d-flex w-100 justify-content-between align-items-center flex-wrap">
                    <div className="text-muted small">
                        Created by <strong>{(data?.assignedBy || {})?.name || '—'}</strong>
                    </div>

                    <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                        {!isExternalEvent && (
                            <Fragment>
                                <div className="d-inline-flex">
                                    <EventAttendanceComponent
                                        key={data}
                                        data={data}
                                        isBusy={isBusy}
                                        conflictEndTime={conflictEndTime}
                                        conflictEventTitle={conflictEventTitle}
                                        updateAttendance={updateAttendance}
                                        userId={currUser?._id}
                                        disabled={isBusy || loadingConflict}
                                        loadingConflict={loadingConflict}
                                        compactMode={true}
                                    />
                                </div>
                                <div>
                                    {(data?.assignedUser || [])?.includes(userId) && (
                                        <Button
                                            variant={isSelfDone ? 'outline-success' : 'outline-secondary'}
                                            onClick={toggleSelfComplete}
                                            className="d-flex align-items-center"
                                            style={{ minWidth: '160px' }}
                                            disabled={isBusy}
                                        >
                                            {isSelfDone ? (
                                                <BsCheckCircle className={`mr-2 ${isBusy && 'spin'}`} />
                                            ) : (
                                                <HiOutlineExclamationCircle className={`mr-2 ${isBusy && 'spin'}`} />
                                            )}
                                            {isSelfDone ? 'Completed' : 'Mark Complete'}
                                        </Button>
                                    )}
                                </div>
                            </Fragment>
                        )}

                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </div>
                </Modal.Footer>
            </div>
        );
    }
);
const mapStateToProps = (state) => ({
    tasks: state.tasks,
    currUser: state.user.user,
});
export default connect(mapStateToProps, {
    editTheTask,
    editMyTask,
    editMyTaskAttendance,
    editTaskStatus,
    startConference,
    setConferenceData,
    fetchUpcomingTasks,
})(PreviewEventModalForm);
